import { useDispatch, useSelector } from "react-redux";

import Header from "./Header";
import LeftSection from "./LeftSection";
import RightSection from "./RightSection";
import style from "./councillor_profile.module.scss";

function CouncillorProfile({ isDetails, fetchCouncillor }) {
  const { selectedCounsilor } = useSelector((state) => state.counsilor);
  const dispatch = useDispatch();

  return (
    <div className="w-full create">
      <Header isDetails={isDetails} />
      <div className={`flex ${style["child-wrapper"]} gap-6 p-6 pt-5 pb-0`}>
        <LeftSection fetchCouncillor={fetchCouncillor} isDetails={isDetails} />
        <RightSection fetchCouncillor={fetchCouncillor} isDetails={isDetails} />
      </div>
    </div>
  );
}

export default CouncillorProfile;
